import {
  Box,
  Column,
  Columns,
  HiddenVisually,
  Stack,
  Text,
} from 'braid-design-system';
import { memo } from 'react';
import { useTranslations } from '@vocab/react';

import { ButtonLink, TextLink } from 'src/components/NavLink/NavLink';
import { useReturnUrl } from 'src/hooks/useReturnUrl';
import { useAnalyticsFacade } from 'src/modules/AnalyticsFacade';

import translations from './.vocab';
import { useBrandName } from 'src/hooks/useBrandName';

const SignedOutDashboard = () => {
  const { t } = useTranslations(translations);
  const brandName = useBrandName();
  const analyticsFacade = useAnalyticsFacade();

  const SIGN_IN = t('Sign in');
  const REGISTER = t('Register');

  const signInLink = useReturnUrl({ mode: 'signin' });
  const registerLink = useReturnUrl({ mode: 'register' });

  return (
    <Box
      component="nav"
      aria-labelledby="SignedOutDashboardHeading"
      padding="gutter"
      paddingY={{ mobile: 'gutter', tablet: 'xlarge' }}
      background="neutralLight"
      borderRadius="xlarge"
      data={{ automation: 'signedOutDashboard' }}
    >
      <HiddenVisually>
        <h1 id="SignedOutDashboardHeading">{t('Sign in or register')}</h1>
      </HiddenVisually>

      <Stack space="medium" align="center">
        <Box width="full" maxWidth="xsmall">
          <Columns space="small" alignY="center">
            <Column>
              <ButtonLink
                tone="neutral"
                variant="ghost"
                location={signInLink}
                onClick={() => {
                  analyticsFacade.signInPressed({
                    linkContext: {
                      linkPosition: 'body',
                      linkText: SIGN_IN,
                    },
                  });
                }}
                rel="nofollow"
                data={{ automation: 'dashboardSignIn' }}
              >
                <span style={{ whiteSpace: 'nowrap' }}>{SIGN_IN}</span>
              </ButtonLink>
            </Column>
            <Column>
              <Text align="center">
                <TextLink
                  hitArea="large"
                  location={registerLink}
                  preNavigationHooks={[
                    () => {
                      analyticsFacade.registerPressed({
                        linkContext: {
                          linkPosition: 'body',
                          linkText: REGISTER,
                        },
                      });
                    },
                  ]}
                  rel="nofollow"
                  data={{ automation: 'dashboardRegister' }}
                >
                  {REGISTER}
                </TextLink>
              </Text>
            </Column>
          </Columns>
        </Box>
        <Text align={{ tablet: 'center' }}>
          {t(
            'Sign in to manage your {brand} Profile, save searches and view your recommended jobs.',
            { brand: brandName },
          )}
        </Text>
      </Stack>
    </Box>
  );
};

export default memo(SignedOutDashboard);
